import { Storage } from '../../core/platform-interfaces/storage'

export class InMemStorage implements Storage {
  _store: Record<string, string> = {}
  getItem(key: string): string | null {
    return this._store[key] || null
  }
  setItem(key: string, value: unknown) {
    this._store[key] = String(value)
  }
}
